export default __webpack_public_path__ + "static/media/AD.90836cb2.svg";